module.exports = __webpack_public_path__ + "static/img/2.c4786f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/2.png
// module id = UCSJ
// module chunks = 0